import * as types from '../constants';

const initialState = {
  standing: [],
  standingStrip: [],
  standings: {},
  standingStrips: {},
};

const findKey = (value, outerGroups) => {
  let ret = [];
  outerGroups.forEach((arr, j) => {
    arr.forEach((v, k) => {
      if (v === value) {
        ret = [j, k];
      }
    });
  });
  return ret;
};

function buildRugbyData(data, phase) {
  data.phaseRequest = phase;

  if (String(phase) !== '2') { return data; }

  const phases = [];
  const reduceGroups = (groups, mod) => {
    const ret = [];
    let temp = [];
    groups.forEach((val, i) => {
      temp.push(val);
      if ((i + 1) % mod === 0 || (i + 1) >= groups.length) {
        ret.push(temp);
        temp = [];
      }
    });
    return ret;
  };

  let outerGroups = [];
  data.contents.forEach((x) => {
    const partite = [];
    const keys = [];
    const groups = [];
    x.games.forEach((game) => { /* ++++++++++++++++++++++++++  GAME  ++++++++++++++++++++++++++ */
      let teamId;
      if (keys.indexOf(game.teamHome.teamId) > -1) {
        ({ teamId } = game.teamHome);
      } else if (keys.indexOf(game.teamAway.teamId) > -1) {
        ({ teamId } = game.teamAway);
      } else {
        keys.push(game.teamHome.teamId);
        ({ teamId } = game.teamHome);
      }
      let key = keys.indexOf(teamId);
      if (outerGroups.length > 0) {
        [key] = findKey(teamId, outerGroups);
        if (typeof groups[key] === 'undefined') {
          groups[key] = [game.teamHome.teamId, game.teamAway.teamId];
        }
      } else {
        if (groups.indexOf(game.teamHome.teamId) < 0) {
          groups.push(game.teamHome.teamId);
        }
        if (groups.indexOf(game.teamAway.teamId) < 0) {
          groups.push(game.teamAway.teamId);
        }
      }
      game.homeTeam = { teamName: game.teamHome.name, teamId: game.teamHome.teamId, score: game.teamHome.score || '' };
      game.awayTeam = { teamName: game.teamAway.name, teamId: game.teamAway.teamId, score: game.teamAway.score || '' };
      if (game.teamHome.score && game.teamAway.score) {
        if (Number(game.teamHome.score) > Number(game.teamAway.score)) {
          game.matchDetails = { winId: game.teamHome.teamId, lostId: game.teamAway.teamId };
        } else {
          game.matchDetails = { winId: game.teamAway.teamId, lostId: game.teamHome.teamId };
        }
      }
      if (game.utcDate) {
        game.dateUtc = game.utcDate;
      }
      if (typeof partite[key] === 'undefined') {
        partite[key] = {
          homeTeam: Object.assign({}, game.homeTeam, { score: 0 }),
          awayTeam: Object.assign({}, game.awayTeam, { score: 0 }),
          matches: [],
          notFinished: false,
        };
      }
      partite[key].matches.push(game);
      if (game.matchDetails.winId && partite[key].homeTeam.teamId === game.matchDetails.winId) {
        partite[key].homeTeam.score += 1;
      }
      if (game.matchDetails.winId && partite[key].awayTeam.teamId === game.matchDetails.winId) {
        partite[key].awayTeam.score += 1;
      }
    }); /* ++++++++++++++++++++++++++  FINE GAME  ++++++++++++++++++++++++++ */
    outerGroups = outerGroups.length === 0 ? reduceGroups(groups, partite.length) : groups;
    phases.push({ roundName: x.roundName, partite });
  });
  data.contents = phases;
  return data;
}

export default function standingsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_STANDINGS_SUCCESS:
      return {
        ...state,
        standings: {
          ...state.standings,
          [action.widgetId]: action.data,
        },
      };
    case types.GET_STANDING_STRIP_SUCCESS:
      return {
        ...state,
        standingStrips: {
          ...state.standingStrips,
          [action.widgetId]: action.data,
        },
      };
    case types.GET_STANDINGS_PHASE_SUCCESS:
      return {
        ...state,
        standings: {
          ...state.standings,
          [action.widgetId]: buildRugbyData(action.data, action.phase),
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/standings.js